
import '../../scss/global/index.scss';
import '../../../i18n';

// Importa el componente raíz y el método de montaje de Svelte
import App from './App.svelte';
import { mount } from 'svelte';
import { logEvent } from '@/utils/logs';


export async function initRemoteApp() {
	try {

	} catch (error) {
		logEvent(`❌ Error re-initializing startup info: ${error}`);
		return false;
	}
}

async function initApp() {
	try {
		console.log("✅ Device is ready");
		const target = document.getElementById('app');
		try {
			if (target) {
				mount(App, {
					target: target,
				});
			} else {
				console.error('No se encontró el elemento con ID "app"');
			}
		} catch (error) {
			console.error('Error al montar el componente:', error);
		}

	} catch (error) {
		logEvent(`❌ Error initializing Firebase App: ${error}`);
	}
}

initApp();